export default __webpack_public_path__ + "static/media/javaHackerRank.a2750b59.jpg";